function closeOpenHotspots(exceptHotspot = null) {
  document.querySelectorAll('.sf-hotspot.is-active').forEach((hotspot) => {
    if (hotspot === exceptHotspot) {
      return;
    }

    hotspot.classList.remove('is-active');

    const button = hotspot.querySelector('.sf-hotspot-btn');
    if (button) {
      button.setAttribute('aria-expanded', 'false');
    }
  });
}

document.addEventListener('click', (event) => {
  const hotspotButton = event.target.closest('.sf-hotspot-btn');

  if (hotspotButton) {
    const hotspot = hotspotButton.closest('.sf-hotspot');

    if (!hotspot) {
      return;
    }

    const shouldOpen = !hotspot.classList.contains('is-active');
    closeOpenHotspots(hotspot);

    hotspot.classList.toggle('is-active', shouldOpen);
    hotspotButton.setAttribute('aria-expanded', String(shouldOpen));
    return;
  }

  if (!event.target.closest('.sf-hotspot')) {
    closeOpenHotspots();
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closeOpenHotspots();
  }
});